import api from './api';

class AgencyService {
  async getAllAgencies(params = {}) {
    const response = await api.get('/agencies', { params });
    return response.data;
  }

  async getAgency(id) {
    const response = await api.get(`/agencies/${id}`);
    return response.data;
  }

  async createAgency(agencyData) {
    const response = await api.post('/agencies', agencyData);
    return response.data;
  }

  async updateAgency(id, agencyData) {
    const response = await api.put(`/agencies/${id}`, agencyData);
    return response.data;
  }

  async deleteAgency(id) {
    const response = await api.delete(`/agencies/${id}`);
    return response.data;
  }

  async getAgencyStatistics(agencyId) {
    const response = await api.get(`/agencies/${agencyId}/statistics`);
    return response.data;
  }

  async getAgenciesOverview() {
    const response = await api.get('/agencies/statistics/overview');
    return response.data;
  }

  async getAgencyUsers(agencyId, params = {}) {
    const response = await api.get(`/agencies/${agencyId}/users`, { params });
    return response.data;
  }

  async getAgencyClients(agencyId, params = {}) {
    const response = await api.get(`/agencies/${agencyId}/clients`, { params });
    return response.data;
  }

  async transferClient(clientId, targetAgencyId) {
    const response = await api.post(`/agencies/transfer-client`, {
      client_id: clientId,
      target_agency_id: targetAgencyId
    });
    return response.data;
  }

  async searchAgencies(query) {
    const response = await api.get('/agencies/search', { params: { q: query } });
    return response.data;
  }

  async exportAgencies(format = 'csv') {
    const response = await api.get('/agencies/export', {
      params: { format },
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new AgencyService();